import React, { useState, useEffect } from 'react'
import "./CSS/Profile.css"
import { connect } from 'react-redux'
import metisbot from "../Assets/metisbot.jpg"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Store from '../Store/Store'
import { setProfilePhoto } from '../Action/Action'

const Profile = (props) => {
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => { console.log(selectedImage); }, [selectedImage])


  const history = useHistory()

  const remove_pp = e => {
    e.preventDefault()
    try {
      setSelectedImage("")
      localStorage.setItem("profile_photo", JSON.stringify(""))
    } catch (err) {
      console.log(err);
    } finally {
      var section_profile = document.querySelector(".profile_section")
      var pop_up = document.querySelector(".choose_pc_or_remove_pop_up")

      pop_up.classList.toggle("choose_pc_or_remove_pop_up_active")
      section_profile.classList.toggle("profile_section_dark")
    }

  }

  useEffect(() => {
    let ls_pp = localStorage.getItem("profile_photo");
    if (ls_pp && ls_pp !== "") {
      setSelectedImage(ls_pp)
    }
  }, [])




  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    console.log(e.target.value);

    reader.onload = async (event) => {
      console.log(event);
      let long_string = event.target.result;
      setSelectedImage(long_string);
      localStorage.setItem("profile_photo", (long_string));
      Store.dispatch(setProfilePhoto(long_string))
    };

    try {
      reader.readAsDataURL(file); // Bu satırın reader.onload'un dışında olması gerekiyor
    } catch (err) {
      console.log(err);
    } finally {
      var section_profile = document.querySelector(".profile_section");
      var pop_up = document.querySelector(".choose_pc_or_remove_pop_up");

      pop_up.classList.toggle("choose_pc_or_remove_pop_up_active");
      section_profile.classList.toggle("profile_section_dark");
    }
  };


  const close_pop_up = e => {
    var section_profile = document.querySelector(".profile_section")
    var pop_up = document.querySelector(".choose_pc_or_remove_pop_up")

    pop_up.classList.toggle("choose_pc_or_remove_pop_up_active")
    section_profile.classList.toggle("profile_section_dark")
  }

  // Change Password Parts

  const [old_password, Set_old_password] = useState("")
  const [set_new_password, Set_new_password] = useState("")

  const [re_new_pwd, Set_re_new_password] = useState("")

  const onchangeFunc = (e) => {
    if (e.target.id === "old_pwd_inputid") {
      Set_old_password(e.target.value)
    } else if (e.target.id === "new_pwd_inputid") {
      Set_new_password(e.target.value)
    } else {
      Set_re_new_password(e.target.value)
    }


  }



  const submitFunc = async (e) => {
    e.preventDefault();

    if (old_password !== "" && set_new_password !== "" && re_new_pwd !== "" && re_new_pwd === set_new_password) {
      document.querySelector("#wers1").innerHTML = ""
      document.querySelector("#wers2").innerHTML = ""
      document.querySelector("#wers3").innerHTML = ""
      try {
        const request = await fetch("https://app-rmmsapi.azurewebsites.net/api/person/ChangePwd", {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "accept": "application/json"
          },
          body: JSON.stringify({
            "email": props.email,
            "password": re_new_pwd
          })
        })

        if (request.status === 200) document.querySelector(".alert_redirect_login").classList.toggle("alert_redirect_login_active");
        const response = await request.json()
        console.log(response);

        document.querySelector(".change_password_pop_up").classList.toggle("change_password_pop_up_active");
        document.querySelector("section.profile_section").style.filter = "brightness(100%)"

      }
      catch (err) {
        console.log(err);
      } finally {
        Set_new_password("")
        Set_old_password("")
        Set_re_new_password("")
      }
    } else {
      if (old_password === "") {
        document.querySelector("#wers1").innerHTML = "Bu alan gerekli!"
      }
      if (set_new_password === "") {
        document.querySelector("#wers2").innerHTML = "Bu alan gerekli!"
      }
      if (re_new_pwd === "") {
        document.querySelector("#wers3").innerHTML = "Bu alan gerekli!"
      } else if (re_new_pwd !== set_new_password) {
        document.querySelector("#wers3").innerHTML = "Parolalar Uyuşmuyor!"

      }
    }
  }


  const open_pop_up = () => {

    document.querySelector("#pick_pp_from_pc").value = ""

    var section_profile = document.querySelector(".profile_section")
    var pop_up = document.querySelector(".choose_pc_or_remove_pop_up")

    pop_up.classList.toggle("choose_pc_or_remove_pop_up_active")
    section_profile.classList.toggle("profile_section_dark")
  }

  return (
    <>
      <div className="change_password_pop_up">
        <i onClick={() => {
          document.querySelector("#wers1").innerHTML = ""
          document.querySelector("#wers2").innerHTML = ""
          document.querySelector("#wers3").innerHTML = ""

          Set_new_password("")
          Set_old_password("")
          Set_re_new_password("")

          document.querySelector(".change_password_pop_up").classList.toggle("change_password_pop_up_active")

          document.querySelector("section.profile_section").style.filter = "brightness(100%)"

        }} style={{ margin: "2px 0", position: "relative", left: "95%", color: "brown", scale: "1.4", cursor: "pointer" }} className="fa fa-times"></i>
        <div className="row">
          <label htmlFor="old password"> Eski Şifre</label>
          <input value={old_password} onChange={onchangeFunc} type="password" className='pwd_input' placeholder='Your current password' id='old_pwd_inputid' />
          <div id='wers1'></div>
        </div>
        <div className="row">
          <label htmlFor="new password"> Yeni Şifre</label>
          <input value={set_new_password} onChange={onchangeFunc} type="password" className='pwd_input' placeholder='Create your new password' id='new_pwd_inputid' />
          <div id='wers2'></div>
        </div>
        <div className="row">
          <label htmlFor="re-new password"> Yeni Şifre Tekrar</label>
          <input value={re_new_pwd} onChange={onchangeFunc} type="password" className='pwd_input' placeholder='Type your new password again ' id='re_new_pwd_inputid' />
          <div id='wers3'></div>
        </div>
        <div style={{ alignItems: "center", width: "100%", marginTop: "1%" }} className="row">
          <button onClick={submitFunc} className="register_change_pwd_profile_btn">
            Yeni Şifre <i className="fa fa-lock"></i>
          </button>
        </div>
      </div>
      <div className="choose_pc_or_remove_pop_up">
        <i onClick={close_pop_up} className="fa fa-times"></i>
        <div>
          <input id='pick_pp_from_pc' type="file" onChange={handleImageUpload} />
          <button onClick={remove_pp}>Profil Fotoğrafını Kaldır</button>
        </div>
      </div>
      <section className="profile_section">
        <div className="top_img_profile">
          <div className="img_top-3x">
            {selectedImage !== "" ? <img src={selectedImage} alt="" /> : <i style={{ fontSize: "32px" }} className='fa-solid fa-user '></i>}
          </div>

          <div className='o-p-u-div' onClick={open_pop_up}><i className="fa fa-plus"></i></div>
        </div>
        <div onClick={() => {
          history.push("/profile/edit")
        }} style={{ marginTop: "-3%" }} className="update_profile">
          Profili Düzenle
        </div>
        <div onClick={() => {
          document.querySelector(".change_password_pop_up").classList.toggle("change_password_pop_up_active");
          document.querySelector("section.profile_section").style.filter = "brightness(50%)"

        }} style={{ marginTop: "2%" }} className="update_profile">
          Şifre Değiştir
        </div>
        <div className="top_of_infos_4 4_x_i">
          <div>
            <span>Şirket</span><span>{props.profile.factory}</span>
          </div>
          <div>
            <span>Departman</span><span>{props.profile.department}</span>
          </div>
          <div>
            <span>Yetkinlik</span><span>{props.profile.competence}</span>
          </div>
          <div>
            <span>Roller</span><span>{props.profile.roles}</span>
          </div>
        </div>
        <div className="bottom_of_infos_xswer">
          <div className="user_info">
            <div className="row">Kullanıcı İsmi: <p>{props.username}</p></div>
            <div className="row">İsim: <p>{props.profile.name}</p></div>
            <div className="row">Soyisim: <p>{props.profile.surname}</p></div>
            <div className="row">Email: <p>{props.email}</p></div>
            <div className="row">Telefon: <p>{props.profile.phone}</p></div>
            <div className="row">Departman: <p>{props.profile.department}</p></div>
            <div className="row">Yetkinlik: <p>{props.profile.competence}</p></div>
            <div className="row">Roller: {props.profile.roles ? props.profile.roles.map((item, index) => {
              var virgül = false;
              if (index !== 0) {
                virgül = true
              }
              return <>{virgül ? <p style={{ marginRight: "4.5%" }}>-</p> : ""}<p className='hjdodf'>{item}</p></>
            }) : ""}</div>
          </div>
          <div className="company_info">
            <div className="row">Şirket: <p>{props.profile.company}</p></div>
            <div className="row">Adres: <p>{props.profile.address}</p></div>
            <div className="row">Email: <p>{props.profile.email2}</p></div>
            <div className="row">Telefon: <p>{props.profile.phone2}</p></div>
            {props.profile.company_img === "" ? <img style={{ position: "relative", left: "35%", top: "2%", width: "100px", height: "100px", border: "none", display: "none" }} src={props.profile.company_img} alt="" /> : <img style={{ position: "relative", left: "35%", top: "2%", width: "100px", height: "100px", border: "none" }} src={props.profile.company_img} alt="" />}
          </div>
        </div>
      </section>
    </>
  )
}

const MapStateToProps = (state) => {
  return {
    profile: state.project_reducer.profile_infos,
    username: state.auth_reducer.username,
    email: state.auth_reducer.email
  }
}

export default connect(MapStateToProps)(Profile)